import { Button as AntdButton } from 'antd';
import type { ComponentProps, ReactNode } from 'react';

import styles from './text-button.module.scss';

type AntdButtonProps = ComponentProps<typeof AntdButton>;

export type TextButtonTone = 'default' | 'brand' | 'danger';
export type TextButtonSize = 'sm' | 'md';

export type TextButtonProps = Omit<
  AntdButtonProps,
  'type' | 'variant' | 'color' | 'icon' | 'size'
> & {
  /** default → text-secondary, brand → brand-600, danger → error-500. */
  tone?: TextButtonTone;
  /** sm = 13px, md = 16px. Default 'md'. */
  size?: TextButtonSize;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
};

export function TextButton({
  tone = 'default',
  size = 'md',
  startIcon,
  endIcon,
  className,
  children,
  ...rest
}: TextButtonProps) {
  return (
    <AntdButton
      {...rest}
      type="link"
      className={[styles.textButton, styles[tone], styles[size], className]
        .filter(Boolean)
        .join(' ')}
    >
      {startIcon ? <span className={styles.icon}>{startIcon}</span> : null}
      {children}
      {endIcon ? <span className={styles.icon}>{endIcon}</span> : null}
    </AntdButton>
  );
}
